export const allSettled = <T>(promises: Array<Promise<T> | void | null | undefined>) =>
  Promise.all(
    promises.map((p: any) =>
      Promise.resolve(p).then(
        value => ({ status: 'fulfilled' as const, value }),
        reason => ({ status: 'rejected' as const, reason })
      )
    )
  );